<template>
  <SlideYUpTransition :duration="animationDuration">
    <b-modal
      class="modal fade"
      ref="app-modal"
      :size="size"
      :hide-header="!$slots.header"
      :modal-class="[{'modal-mini': type === 'mini'}, ...modalClasses]"
      @mousedown.self="closeModal"
      tabindex="-1"
      role="dialog"
      centered
      @close="closeModal"
      @hide="closeModal"
      :header-class="headerClasses"
      :footer-class="footerClasses"
      :content-class="[gradient ? `bg-gradient-${gradient}` : '', ...modalContentClasses]"
      :body-class="bodyClasses"
      :aria-hidden="!show"
    >
      <!-- Header -->
      <template v-slot:modal-header>
        <slot name="header"></slot>
        <slot name="close-button">
          <button
            type="button"
            class="close"
            v-if="showClose"
            @click="closeModal"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span :aria-hidden="!show">×</span>
          </button>
        </slot>
      </template>

      <!-- Body -->
      <slot />

      <!-- Footer -->
      <template v-slot:modal-footer>
        <slot name="footer"></slot>
      </template>
    </b-modal>
  </SlideYUpTransition>
</template>

<script>
import { SlideYUpTransition } from "vue2-transitions";

export default {
  name: "modal",
  components: {
    SlideYUpTransition,
  },
  props: {
    show: Boolean,
    showClose: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "",
      validator(value) {
        let acceptedValues = ["", "notice", "mini"];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: 'Modal type (notice|mini|"")',
    },
    modalClasses: {
      type: [Array, Object, String],
      default: () => [],
      description: "Modal dialog CSS classes",
    },
    size: {
      type: String,
      default: "",
      validator(value) {
        let acceptedValues = ["", "sm", "lg", "xl"];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: "Modal size",
    },
    modalContentClasses: {
      type: [Array, Object, String],
      default: () => [],
      description: "Modal dialog content CSS classes",
    },
    gradient: {
      type: String,
      description: "Modal gradient type (danger, primary, etc)",
    },
    headerClasses: {
      type: [Array, Object, String],
      default: () => [],
      description: "Modal Header CSS classes",
    },
    bodyClasses: {
      type: [Array, Object, String],
      default: () => [],
      description: "Modal Body CSS classes",
    },
    footerClasses: {
      type: [Array, Object, String],
      default: () => [],
      description: "Modal Footer CSS classes",
    },
    animationDuration: {
      type: Number,
      default: 500,
      description: "Modal transition duration (ms)",
    },
  },
  data() {
    return {
      mountedReady: false,
    };
  },
  mounted() {
    // Mark component as ready after mounting
    this.mountedReady = true;

    // Show modal if initial prop is true
    this.$nextTick(() => {
      if (this.show && this.$refs["app-modal"]) {
        this.$refs["app-modal"].show();
      }
    });
  },
  watch: {
    show(val) {
      // Avoid running before component fully mounted
      if (!this.mountedReady) return;

      this.$nextTick(() => {
        const modal = this.$refs["app-modal"];
        if (!modal) return; // skip if ref belum wujud

        try {
          val ? modal.show() : modal.hide();
        } catch (err) {
          console.warn("Modal belum siap:", err);
        }
      });
    },
  },
  methods: {
    closeModal() {
      this.$emit("update:show", false);
      this.$emit("close");
    },
  },
};
</script>

<style>
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.6) !important;
}
</style>
